<footer [ngClass]="isInnerPage ? 'inner-page' : ''">
    <div class="container">
        <div class="row">
        </div>
    </div>
</footer>
